webpackJsonp([5],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(254);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(131);

var _router2 = _interopRequireDefault(_router);

__webpack_require__(171);

__webpack_require__(178);

var _util = __webpack_require__(133);

var _util2 = _interopRequireDefault(_util);

var _vant = __webpack_require__(36);

var _vant2 = _interopRequireDefault(_vant);

__webpack_require__(170);

var _http = __webpack_require__(132);

var _vueAwesomeSwiper = __webpack_require__(252);

var _vueAwesomeSwiper2 = _interopRequireDefault(_vueAwesomeSwiper);

__webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_util2.default);

_vue2.default.use(_vant2.default);

_vue2.default.prototype.$http = _http.apiAxios;

_vue2.default.use(_vueAwesomeSwiper2.default);

new _vue2.default({
    el: '#app',
    router: _router2.default,
    components: { App: _App2.default },
    template: '<App/>'
});

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {};
  },

  computed: {
    key: function key() {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
    }
  }
};

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(8);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(256);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [{
    path: "/",
    name: "index",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(265)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/contract",
    name: "contract",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/game",
    name: "game",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(263)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}, {
    path: "/app",
    name: "app",
    component: function component(resolve) {
        return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(262)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
}];

var router = new _vueRouter2.default({
    mode: 'history',
    disableDotRule: true,
    routes: routes
});
exports.default = router;

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(134);

var _promise2 = _interopRequireDefault(_promise);

exports.apiAxios = apiAxios;

var _axios = __webpack_require__(113);

var _axios2 = _interopRequireDefault(_axios);

var _vant = __webpack_require__(36);

var _qs = __webpack_require__(180);

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.timeout = 50000;
_axios2.default.interceptors.request.use(function (config) {
    var user = "";
    if (user) {
        config.headers = {
            Authorization: "bearer " + user.token
        };
    }
    config.headers = {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8;'
    };
    return config;
}, function (error) {
    return _promise2.default.reject(error);
}, function (error) {
    return _promise2.default.reject(error);
});

_axios2.default.interceptors.response.use(function (res) {
    var code = res.data.code,
        message = res.data.msg;
    switch (code) {
        case 1:
            return res;
            break;
        default:
            _vant.Dialog.alert({
                title: "提示",
                message: message ? message : "网络请求异常，请稍候再试"
            }).then(function (r) {
                return function () {};
            });
            break;
    }
}, function (error) {
    _vant.Dialog.alert({
        title: '提示',
        message: error.message.includes('timeout') ? '网络请求超时，请稍候再试' : '网络请求异常，请稍候再试'
    }).then(function (r) {
        return function () {};
    });
    return _promise2.default.reject(error);
});

function apiAxios(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "post";
    var loading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (loading) {
        _vant.Toast.loading({
            message: "加载中...",
            duration: 1000000
        });
    }
    method = method.toUpperCase();
    var config = {
        method: method,
        url: url,
        transformRequest: [function (data) {
            return _qs2.default.stringify(params);
        }]
    };

    return new _promise2.default(function (resolve, reject) {
        (0, _axios2.default)(config).then(function (res) {
            if (loading) {
                _vant.Toast.clear();
            }
            if (res) {
                if (res.status === 200) {
                    resolve(res.data);
                }
            }
        }).catch(function (response) {
            if (loading) {
                _vant.Toast.clear();
            }
            reject(response);
        });
    });
}

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vant = __webpack_require__(36);

exports.default = {

    install: function install(Vue, options) {
        Vue.prototype.BRToast = function () {
            var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '提示';

            (0, _vant.Toast)({
                mask: false,
                message: title
            });
        };

        Vue.prototype.BRDialog = function () {
            var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '提示';
            var message = arguments[1];
            var yesCallback = arguments[2];
            var cancelCallback = arguments[3];

            _vant.Dialog.confirm({
                title: title,
                message: message,
                showCancelButton: false }).then(function () {
                if (yesCallback) {
                    yesCallback();
                }
            }).catch(function () {
                if (cancelCallback) {
                    cancelCallback();
                }
            });
        };

        Vue.prototype.BRShowLoad = function () {
            var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '加载中';
            var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;

            _vant.Toast.loading({
                mask: true,
                message: title,
                duration: duration,
                forbidClick: true });
        };

        Vue.prototype.BRHideLoad = function () {
            _vant.Toast.clear();
        };

        Vue.prototype.BRUrlBack = function () {
            this.$router.back(-1);
        };

        Vue.prototype.isSetString = function (str) {
            if (str !== null && str !== undefined && str !== '') {
                return true;
            } else {
                return false;
            }
        };
        Vue.prototype.dataEq = function (str1, str2) {
            if (str1 !== str2) {
                return false;
            } else {
                return true;
            }
        };

        Vue.prototype.runRomSystem = function () {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
            var isIOS = u.match(/iPhone|iPad|iPod|ipad|Mac|mac/i);
            var isIE = u.match(/IEMobile/i);
            return isIOS ? 'ios' : 'android';
        };

        Vue.prototype.isRunInWeChatApp = function () {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        };

        Vue.prototype.getUrlParamsCode = function () {
            var URLParams = new Array();
            var aParams = document.location.search.substr(1).split('&');
            for (var i = 0; i < aParams.length; i++) {
                var aParam = aParams[i].split('=');
                URLParams[aParam[0]] = decodeURI(aParam[1]);
            }
            return URLParams;
        };
    }
};

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 172:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(172)

var Component = __webpack_require__(111)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 255:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
module.exports = __webpack_require__(107);


/***/ })

},[259]);


// WEBPACK FOOTER //
// static/js/app.ba578c3dc35118490560.js